import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum LevelOfCareFilterEnum {
    "Routine Home Care" = 1 as number,
    "Respite Care" = 3 as number,
    "General Inpatient Care" = 4 as number,
    "Continuous Care" = 5 as number
}
class LevelOfCareFilterClass extends EnumWithDescription<LevelOfCareFilterEnum> {
    public readonly enum = LevelOfCareFilterEnum;
    public readonly enumName: string = "LevelOfCareFilterEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<LevelOfCareFilterEnum>> = new Map([
        [
            "Routine Home Care",
            {
                name: "Routine Home Care",
                value: 1
            }
        ],
        [
            "Respite Care",
            {
                name: "Respite Care",
                value: 3
            }
        ],
        [
            "General Inpatient Care",
            {
                name: "General Inpatient Care",
                value: 4
            }
        ],
        [
            "Continuous Care",
            {
                name: "Continuous Care",
                value: 5
            }
        ]
    ]);
}

export const LevelOfCareFilters = new LevelOfCareFilterClass();
